import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

import { AddUserEmailConfigComponent } from './add-user-email-config/add-user-email-config.component';
import { AddUserEnvironmentComponent } from './add-user-environment/add-user-environment.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {ConfService} from '../../conf.service';
import {KongService} from '../../kong.service';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {AccountInfoService} from '../../user/account-info.service';
import {Router} from '@angular/router';
import {EmailtemplateService} from '../../emailtemplate.service';
import {FormControl} from '@angular/forms';
import {environment} from '../../../environments/environment';
import {ResetPasswordDialogComponent} from '../../manage-users1/reset-password-dialog/reset-password-dialog.component';
import {LeftpanelNewComponent} from '../../leftpanel-new/leftpanel-new.component';
import {interval} from 'rxjs';
import {AdminEnvironmentHandlerService} from '../../admin-environment-handler.service';
import {PartnerSettingsService} from '../../partnerSettings/partner-settings.service';
import {ViewExclusionsDialogComponent} from '../view-exclusions-dialog/view-exclusions-dialog.component';


@Component({
  selector: 'app-manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.scss']
})
export class ManageUsersComponent implements OnInit, OnChanges {

  selectedUser: any;
  displayedColumns: string[] = [
    'actions',
    'environment',
    'password',
    'role',
    'exclusions',
  ];

  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');
  userDetails: any;
  dataFound = false;
  Roles = new FormControl();
  rolesList: any;
  filterData: any[];
  settings = {text: 'Select Roles'};
  searchText: any;
  select = true;
  environments = [];
  environmentList = [];
  associatedEnvironments = [];

  constructor(
      public dialog: MatDialog,
      private confPost: ConfService,
      private kongService: KongService,
      public platform: LeftpanelNewComponent,
      public _service: ConnecttocrudService,
      public accountInfoService: AccountInfoService,
      public router: Router,
      public emailTemplateInstance: EmailtemplateService,
      private adminEnvironmenthandler: AdminEnvironmentHandlerService,
      private partnerSettingsService: PartnerSettingsService
  ) {}

  getEnvironments() {
    this.confPost.getSettingsV2CRUD(this.partner, this.partner, false).subscribe(response => {
      if (response) {
        for (const item of response['body'][0]['environments']) {
          this.environmentList.push(item['name']);
        }
      }
    });
  }

  getRolesForUserAndPlatform() {
    return new Promise((resolve, reject) => {
      let data = [];
      const platformRoles = new Promise((resolve1, reject1) => {
        this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'partner.in=services' + '&&type.in=platform').subscribe(data1 => {
          if (data1) {
            data = data.concat(data1);
          }
          resolve1('success');
        }, error => {
          resolve1('success');
        });
      });

      const accountRoles = new Promise((resolve1, reject1) => {
        this._service.getItemswithParameter('v1',
            environment.accessPartner,
            environment.accessPartner,
            'roles',
            'partner.in=' + localStorage.getItem('partner') + '&&type.in=account').subscribe(data2 => {
          if (data2) {
            data = data.concat(data2);
          }
          resolve1('success');
        }, error => {
          resolve1('success');
        });
      });

      Promise.all([platformRoles, accountRoles]).then(resp => {
        resolve(data);
      });
    });
  }

  getUserRoleData2(adminEmail, partner) {
    let userDetails: any;
    let queryEmails = adminEmail;
    let tempSelectedUser: any;
    this.userDetails = [];
    if (this.selectedUser) tempSelectedUser = this.selectedUser;
    this.selectedUser = null;
    const signInEmail = localStorage.getItem('signInEmail');
    if (signInEmail !== queryEmails) {
      queryEmails = queryEmails + ',' + signInEmail;
    }
    this._service.getItemswithParameter('v1',  environment.accessPartner, environment.accessPartner, 'users', 'created_by=' + queryEmails + '&partner=' + partner).subscribe(data1 => {
      if (data1) {
        userDetails = data1;
        if (userDetails.length > 0) {
          Promise.resolve(this.getRolesForUserAndPlatform()).then(data => {
            if (data) {
              for (const user of userDetails) {
                if (user['status']) {
                  user['verification'] = 'verified';
                } else {
                  user['verification'] = 'Not verified';
                }
                const shortName = user['user'].split('-');
                user['type'] = shortName[0];
                user['showActions'] = false;
                user['resetPassword'] = false;
                if (signInEmail === adminEmail) {
                  if (user['email'] === adminEmail) {
                    user['showActions'] = false;
                  } else {
                    user['showActions'] = true;
                  }
                  user['resetPassword'] = true;
                } else {
                  if (user['email'] === adminEmail) {
                    user['showActions'] = false;
                  } else if (user['email'] === signInEmail) {
                    user['showActions'] = false;
                    user['resetPassword'] = user['resetPassword'];
                  } else {
                    user['showActions'] = true;
                  }
                }

                const eList = [];
                for (const e of user['environments']) {
                  const shortcode = e['name'].split('-');
                  e['type'] = shortcode[0];
                  e['showActions'] = user['showActions'];
                  e['resetPassword'] = user['resetPassword'];
                  e['editStatus'] = true;
                  e['roles' + e['name']] = e['roles'];
                  e['rolesList'] = data;
                  eList.push(e['name']);
                  if (e['type'] !== 'admin')  {
                    const role_list = [];
                    e['platform_roles'] = [];
                    for (const eee of e['rolesList']) {
                      if ((eee['role'] !== 'Platform Admin' &&
                          eee['role'] !== 'Super Admin' &&
                          eee['type'] === 'platform') ||
                          (!eee['role'].includes('=>') &&
                              eee['type'] === 'account')) {
                        role_list.push(eee);
                        e['platform_roles'].push(eee['id']);
                      }
                    }
                    e['rolesList'] = role_list;
                  } else {
                    const role_list = [];
                    e['platform_roles'] = [];
                    for (const eee of e['rolesList']) {
                      if ((eee['role'] === 'Platform Admin' &&
                          eee['type'] === 'platform')  ||
                          (!eee['role'].includes('=>') &&
                              eee['type'] === 'account')) {
                        role_list.push(eee);
                        e['platform_roles'].push(eee['id']);
                      }
                    }
                    e['rolesList'] = role_list;
                  }
                  e['exlusions_peresent'] = false;
                  if (e['exclusions']['permission_groups'].length > 0) {
                    e['exlusions_peresent'] = true ;
                    this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissiongroups', 'id.in=' + e['exclusions']['permission_groups'].toString()).subscribe(permissiongroups => {
                      e['exclusions']['permission_groups'] = permissiongroups;
                    });
                  }
                  if (e['exclusions']['permissions'] > 0) {
                    e['exlusions_peresent'] = true ;
                    this._service.getItemswithParameter('v1',
                        environment.accessPartner,
                        environment.accessPartner,
                        'permissions',
                        'id.in=' + e['exclusions']['permissions'].toString()).subscribe(permissions => {
                      e['exclusions']['permissions'] = permissions;
                    });
                  }

                  if (e['exclusions']['roles'] > 0) {
                    e['exlusions_peresent'] = true ;
                    this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'id.in=' + e['exclusions']['permissions'].toString()).subscribe(roles => {
                      e['exclusions']['roles'] = roles;
                    });
                  }
                }
                user['environmentList'] = eList;
              }
              this.selectedUser = tempSelectedUser ? tempSelectedUser : userDetails[0];
              this.userDetails = userDetails;
              this.dataFound = true;
            }
          });
        }
      }
    });
  }

  getUserRoleData(adminEmail, partner) {
    let userDetails: any;
    let queryEmails = adminEmail;

    let tempSelectedUser: any;
    if (this.selectedUser) tempSelectedUser = this.selectedUser;
    this.selectedUser = null;


    const signInEmail = localStorage.getItem('signInEmail');
    if (signInEmail !== queryEmails) {
      queryEmails = queryEmails + ',' + signInEmail;
    }
    this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'created_by=' + queryEmails + '&partner=' + partner).subscribe(data1 => {
      if (data1) {
        userDetails = data1;
        if (userDetails.length > 0) {
          Promise.resolve(this.getRolesForUserAndPlatform()).then(data => {
            if (data) {
              for (const user of userDetails) {
                if (user['status']) {
                  user['verification'] = 'verified';
                } else {
                  user['verification'] = 'Not verified';
                }
                const shortName = user['user'].split('-');
                user['type'] = shortName[0];
                user['showActions'] = false;
                user['resetPassword'] = false;
                if (signInEmail === adminEmail) {
                  if (user['email'] === adminEmail) {
                    user['showActions'] = false;
                  } else {
                    user['showActions'] = true;
                  }
                  user['resetPassword'] = true;
                } else {
                  if (user['email'] === adminEmail) {
                    user['showActions'] = false;
                  } else if (user['email'] === signInEmail) {
                    user['showActions'] = false;
                    user['resetPassword'] = user['resetPassword'];
                  } else {
                    user['showActions'] = true;
                  }
                }

                const eList = [];
                for (const e of user['environments']) {
                  const shortcode = e['name'].split('-');
                  e['type'] = shortcode[0];
                  e['showActions'] = user['showActions'];
                  e['resetPassword'] = user['resetPassword'];
                  e['editStatus'] = true;
                  e['roles' + e['name']] = e['roles'];
                  e['rolesList'] = data;
                  eList.push(e['name']);
                  if (e['type'] !== 'admin') {
                    const role_list = [];
                    e['platform_roles'] = [];
                    for (const eee of e['rolesList']) {
                      if ((eee['role'] !== 'Platform Admin' &&
                              eee['role'] !== 'Super Admin' &&
                              eee['type'] === 'platform') ||
                          (!eee['role'].includes('=>') &&
                              eee['type'] === 'account')) {
                        role_list.push(eee);
                        e['platform_roles'].push(eee['id']);
                      }
                    }
                    e['rolesList'] = role_list;
                  } else {
                    const role_list = [];
                    e['platform_roles'] = [];
                    for (const eee of e['rolesList']) {
                      if ((eee['role'] === 'Platform Admin' &&
                              eee['type'] === 'platform') ||
                          (!eee['role'].includes('=>') &&
                              eee['type'] === 'account')) {
                        role_list.push(eee);
                        e['platform_roles'].push(eee['id']);
                      }
                    }
                    e['rolesList'] = role_list;
                  }
                  e['exlusions_peresent'] = false;
                  if (e['exclusions']['permission_groups'].length > 0) {
                    e['exlusions_peresent'] = true;
                    this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'permissiongroups', 'id.in=' + e['exclusions']['permission_groups'].toString()).subscribe(permissiongroups => {
                      e['exclusions']['permission_groups'] = permissiongroups;
                    });
                  }
                  if (e['exclusions']['permissions'] > 0) {
                    e['exlusions_peresent'] = true;
                    this._service.getItemswithParameter('v1',
                        environment.accessPartner,
                        environment.accessPartner,
                        'permissions',
                        'id.in=' + e['exclusions']['permissions'].toString()).subscribe(permissions => {
                      e['exclusions']['permissions'] = permissions;
                    });
                  }

                  if (e['exclusions']['roles'] > 0) {
                    e['exlusions_peresent'] = true;
                    this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'roles', 'id.in=' + e['exclusions']['permissions'].toString()).subscribe(roles => {
                      e['exclusions']['roles'] = roles;
                    });
                  }
                }
                user['environmentList'] = eList;
              }
              this.userDetails = userDetails;
              this.selectedUser = tempSelectedUser ? this.findUserById(tempSelectedUser.id) : userDetails[0];
              this.dataFound = true;
            }
          });
        }
      }
    });
  }

  findUserById(userId) {
    return this.userDetails.find(user => user.id === userId);
  }


  async getUserDetails(softLoader = false) {
    this.dataFound = softLoader;

    if (this.platform.settingsData !== null && this.platform.settingsData !== undefined) {
      const adminEmail = this.platform.settingsData['body'][0]['email'];
      const partner = this.platform.settingsData['body'][0]['partner_name'];
      this.getUserRoleData(adminEmail, partner);
    } else {
      await this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(response => {
        if (response['body'] && response['body'][0]) {
          this.platform.settingsData = response;
          const adminEmail = this.platform.settingsData['body'][0]['email'];
          const partner = this.platform.settingsData['body'][0]['partner_name'];
          this.getUserRoleData(adminEmail, partner);
        }
      });
    }

  }

  deleteRoleForEachEnvironment(id) {
    return new Promise((resolve, reject) => {
      this._service.deleteItem(id, 'v1', environment.accessPartner, environment.accessPartner, 'roles').subscribe(data => {
        if (data) {
          resolve('success');
        } else {
          resolve('failed');
        }
      }, error => {
        resolve('failed');

      });
    });
  }

  deleteEnvironment(eid, account, uid, email) {
    if (confirm('This action is irreversible, Are you sure you want to delete this user?')) {
      this._service.getItemswithParameter('v1',
          environment.accessPartner,
          environment.accessPartner,
          'roles',
          'role=' + eid + '=>' + account + '=>' + email).subscribe(async res => {
        const tempRole = res[0];
        if (tempRole) {
          await this.deleteRoleForEachEnvironment(res[0]['id']);
        }
        this._service.getItemswithParameter('v1',
            environment.accessPartner,
            environment.accessPartner,
            'users',
            'id=' + uid).subscribe(data => {
          let environments: any;
          if (data && data[0] && data[0].hasOwnProperty('environments')) {
            environments = data[0]['environments'];
            if (environments.length > 0) {
              const temp = environments.filter(value => value['name'] !== eid);
              this._service.patchItemUpdate(uid,
                  {environments: temp},
                  'v1',
                  environment.accessPartner,
                  environment.accessPartner,
                  'users').subscribe(data => {
                this.platform.openSnackBar(' Environments deleted successfully', 'Success', {
                  duration: 2000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
                this.getUserDetails(true);
              });
            }
          }
        });
      });
    }
  }

  deleteUser(id, username, status, emailId, environments) {
    if (confirm('This action is irreversible, Are you sure you want to delete this user?')) {
      for (let e of environments) {
        this._service.getItemswithParameter('v1',
            environment.accessPartner,
            environment.accessPartner,
            'roles', 'role=' + e['name'] + '=>' + e['account'] + '=>' + emailId).subscribe(async res => {
          let roles: any;
          roles = res;
          if (roles && roles.length > 0 ) {
            await this.deleteRoleForEachEnvironment(roles[0]['id']);
          }
        });
      }
      this._service.deleteItem(id, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(data => {
        if (status && confirm('This action is irreversible, Are you sure you want to delete the associated consumer account?')) {
          this.kongService.getKongGatewayConsumerDetails(emailId).subscribe(consumerDetail => {
            const res = consumerDetail['data'][0];
            this.kongService.deletKongConsumer(res['id']).subscribe(deletRes => {
              if (deletRes) {
                this.platform.openSnackBar(' User and Consumer accounts deleted successfully', 'Success', {
                  duration: 2000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
              }
              this.selectedUser = null;
              this.getUserDetails();
            });
          });
        } else {
          this.platform.openSnackBar(' User account deleted successfully', 'Success', {
            duration: 2000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.selectedUser = null;
          this.getUserDetails();
        }
      });
    }
  }

  resetPassword(element) {
    const i = this.selectedUser['environments'].findIndex(env => env === element);
    const dialogRef = this.dialog.open(ResetPasswordDialogComponent, {
      width: '25%',
      data: {
        user: this.selectedUser,
        environementIndex: i
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'success') {
        this.platform.openSnackBar(' Password has been changed ', 'Success', {
          duration: 2000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.getUserDetails(true);
      }
    });
  }

  submitEnvironment(element) {
    const index = this.selectedUser['environments'].findIndex(env => env === element);
    const id = this.selectedUser['id'];
    const ngmodelName = 'roles' + element['name'];
    this.selectedUser['environments'][index]['editStatus'] = true;
    if (this.selectedUser['environments'][index][ngmodelName]) {
      this._service.getItemswithParameter('v1',
          environment.accessPartner,
          environment.accessPartner,
          'users',
          'id=' + id).subscribe(data => {
        const temp = data[0]['environments'][index]['roles'].filter(value => !this.selectedUser['environments'][index]['platform_roles'].includes(value));
        data[0]['environments'][index]['roles'] = temp.concat(this.selectedUser['environments'][index][ngmodelName]);
        this._service.patchItemUpdate(id, {environments: data[0]['environments']},
            'v1',
            environment.accessPartner,
            environment.accessPartner,
            'users').subscribe(response => {
          if (response) {
            this.platform.openSnackBar(' Environments Updated', 'Success', {
              duration: 2000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            this.getUserDetails();
          }
        });
      });
    }
  }

  reRoute(id, environment) {
    this.router.navigateByUrl('/assign-roles?type=users&&id=' + id + '&&environment=' + environment);
  }

  editSelect(environment: any) {
    const index = this.selectedUser['environments'].findIndex((env) => env === environment);
    this.selectedUser['environments'][index]['editStatus'] = false;
  }

  cancelEdit(environment: any) {
    const index = this.selectedUser['environments'].findIndex((env) => env === environment);
    this.selectedUser['environments'][index]['editStatus'] = true;
  }

  onUserSelected(user: any) {
    this.selectedUser = user;
  }

  dataSource = new MatTableDataSource<any>(this.selectedUser);

  addEnvironmentDialog(): void {
    const environmentList = this.environmentList.filter(env => {
      if (!this.selectedUser['environmentList'].includes(env)) {
        return env;
      }
    });
    const dialogRef = this.dialog.open(AddUserEnvironmentComponent, {
      width: '60%',
      panelClass: 'dialog-color',
      data: {
        id: this.selectedUser['id'],
        environmentList: environmentList,
        emailId: this.selectedUser['email']
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'success') {
        this.platform.openSnackBar(' New Environment Added ', 'Success', {
          duration: 2000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.getUserDetails(true);
      }
    });
  }

  addUserDialog(type): void {
    const dialogRef = this.dialog.open(AddUserEmailConfigComponent, {
      width: '60%',
      panelClass: 'dialog-color',
      data: {
        users: this.userDetails
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined && result !== '') {
        this.getUserDetails();
      }
    });
  }

  redirect(route: string) {
    this.router.navigate([route]);
  }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    const partnerSettingsSubscription = interval(500).subscribe((async x => {
      if (this.partnerSettingsService.hasPartnerSettingsDataSet()) {
        partnerSettingsSubscription.unsubscribe();
        let environmentData = this.partnerSettingsService.environment;
        if (!environmentData.name.includes('admin')) {
          this.redirect('/console');
        } else {
          this.getEnvironments();
          this.getUserDetails();
        }
        this.adminEnvironmenthandler.onEnvironmentChange.subscribe(async env => {
          this.partnerSettingsService.changeEnvironment();
          environmentData = this.partnerSettingsService.environment;
          if (!environmentData.name.includes('admin')) {
            this.redirect('/console');
          } else {
            this.getEnvironments();
            this.getUserDetails();
          }
        });
      }
    }));
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
  }

  viewExclusions(exclusion: any) {
    const dialogRef = this.dialog.open(ViewExclusionsDialogComponent, {
      width: '40%',
      panelClass: 'dialog-color',
      data: {
        title: 'Exclusions',
        element: exclusion
      }
    });
  }

  refreshPage(){
    this.platform.initialisePlatform();
  }


}
